
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';

const AdminTicketDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  return (
    <div className="space-y-6">
      <div className="flex items-center">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navigate('/admin/support')}
          className="mr-4"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to List
        </Button>
        <h2 className="text-xl font-semibold">Ticket Details</h2>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Ticket #{id}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="py-8 text-center">
            <p className="text-muted-foreground">Ticket details feature is under development...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminTicketDetail;
